import { useOfferDetails } from '../../hooks';
import { TransactionProgress } from './my-offer-steps-buyer';
import { EoiStatusCard } from './eoi-status';
import { SubmittedEoiCard } from './submitted-eoi-info';
import { OfferDetails } from '../../types';
import { EoiActionContainer } from './eoi-actions';
import { OfferDealManager } from './offer-deal-manager';
import { OfferFloatingBanner } from './eoi-actions/offer-floating-banner';

export type OfferViewProps = {
  readonly id: string;
  readonly mode: string | null;
};

export function NewOfferView({ id: offerId, mode }: OfferViewProps) {
  const offer: OfferDetails | null = useOfferDetails(offerId);
  if (!offer) return null;

  const resolvedMode = mode === 'seller' || mode === 'buyer' ? mode : null;

  return (
    <>
      <div className="mt-14 mb-6 grid grid-cols-1 gap-6 md:mt-4 lg:mt-0 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <TransactionProgress progress={offer.transactionProgress} />
          <EoiStatusCard offer={offer} />
          <SubmittedEoiCard offer={offer} />
        </div>
        <div className="lg:col-span-1">
          <EoiActionContainer offer={offer} mode={mode} />
          <OfferDealManager />
        </div>
      </div>

      {/* Mobile floating banner + modals */}
      {resolvedMode && <OfferFloatingBanner offer={offer} mode={resolvedMode} />}
    </>
  );
}
